(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Accordion"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="accordion"] .accordion').forEach((accordion)=>{
	accordion.querySelector('.accordion-heading').addEventListener("click",()=>{
	  accordion.parentNode.querySelectorAll('.accordion').forEach((sibling)=>sibling.classList.remove("active"));
      accordion.classList.toggle("active");
  });
});

  } catch(e) { console.error(e); }
})();
})();
